import { Box, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import React, { useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useNavigate } from 'react-router';
import { UseMutateFunction } from 'react-query';
import { CadastroModelo, CampoCadastro } from '../../../interface/ICadastroModelo';

type ModeloCadastroItemProps = {
  form: CadastroModelo,
  duplicateCadastroModelo: UseMutateFunction<any, any, { nomeModelo: string, campos: CampoCadastro[] }, any>,
  inactivateCadastroModelo: UseMutateFunction<any, any, { nomeModelo: string, cadastroModeloId: string }, any>,
  onItemClick?: (form: CadastroModelo) => void,
  onDuplicate?: (form: CadastroModelo) => void,
  showDuplicate?: boolean,
  deleteLabel?: string,
}

const ModeloCadastroItem = ({ form, duplicateCadastroModelo, inactivateCadastroModelo, onItemClick, onDuplicate, showDuplicate = true, deleteLabel = 'Inativar' }: ModeloCadastroItemProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  function handleMenuAction(action: () => void) {
    action();
    setAnchorEl(null);
  };

  const getDate = (dataAlteração?: number, dataCriacao?: number) => {
    if (!dataAlteração || Number.isNaN(dataAlteração)) return 'Sem data';
    if (dataAlteração === dataCriacao && dataCriacao) return `Criado dia ${new Date(dataCriacao).toLocaleDateString()} às ${new Date(dataCriacao).toLocaleTimeString('PT-BR', { hour12: false }).slice(0, -3)}`;
    return `Editado dia ${new Date(dataAlteração).toLocaleDateString()} às ${new Date(dataAlteração).toLocaleTimeString('PT-BR', { hour12: false }).slice(0, -3)}`;
  }

  return (
    <>
      <Stack direction='row' alignItems='center' justifyContent='space-between' onClick={() => onItemClick ? onItemClick(form) : navigate(`/cadastro-modelo/${form.empresa}/${form.id}`, { state: { cadastroModelo: form } })} borderRadius={2} sx={{ '&:hover': { bgcolor: 'grey.100', cursor: 'pointer' } }} padding={2} width='100%'>
        <Stack direction='row' alignItems='center' spacing={2}>
          <Stack padding={1} bgcolor='#00C4A712' borderRadius={2}><AssignmentIcon color="success" /></Stack>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant='body1' color='textPrimary' sx={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>{form.nome || 'Cadastro-modelo sem nome'}</Typography>
            {form.dataAlteracao && <Typography variant='body2' color='textSecondary'>{getDate(form.dataAlteracao, form.dataCriacao)}</Typography>}
          </Box>
        </Stack>
        <IconButton
          sx={{ zIndex: 10 }}
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(e.currentTarget);
          }}
        >
          <MoreVertIcon />
        </IconButton>
      </Stack>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {showDuplicate && <MenuItem sx={{ display: "flex", gap: 1 }} onClick={() => handleMenuAction(() => onDuplicate ? onDuplicate(form) : duplicateCadastroModelo({ nomeModelo: form.nome || 'Cadastro-modelo', campos: form.campos || [] }))} >
          <FileCopyOutlinedIcon /> Duplicar
        </MenuItem>}
        <MenuItem sx={{ display: "flex", gap: 1, color: 'error.main' }} onClick={() => handleMenuAction(() => inactivateCadastroModelo({ nomeModelo: form.nome, cadastroModeloId: form.id || '' }))} >
          <DeleteOutlineOutlinedIcon /> {deleteLabel}
        </MenuItem>
      </Menu>
    </>
  )
}

export default React.memo(ModeloCadastroItem);
